import { styled, css } from 'next-yak'

import * as copy from './copy'
import * as colors from '../constants/colors'
import * as heading from './heading'
import { Polymorphic, PolymorphicComponent, YakComponentOf } from '@owl-nest/yak/extra-runtime'

export const _titleStyle = css`
  margin: 25px 0 20px;
`

export const Title = styled(heading.M).attrs((props) => ({
  as: 'h1',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h1'>

export const Title2 = styled(heading.S).attrs((props) => ({
  as: 'h2',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h2'>

export const Title3 = styled(heading.XS).attrs((props) => ({
  as: 'h3',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h3'>

export const Title4 = styled(heading.XXS).attrs((props) => ({
  as: 'h4',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h4'>

export const Title5 = styled(heading.XXXS).attrs((props) => ({
  as: 'h5',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h5'>

export const Title6 = styled(heading.XXXXS).attrs((props) => ({
  as: 'h6',
  ...props,
}))`
  ${_titleStyle}
` as YakComponentOf<'h6'>

export const _paragraphStyle = css`
  ${copy.styles.S.regular};
`

export const Paragraph = styled(Polymorphic.p)`
  ${_paragraphStyle}
` as YakComponentOf<PolymorphicComponent<'p'>>

export const _boldStyle = css`
  font-weight: 600;
`

export const Bold = styled.strong`
  ${_boldStyle}
`

export const _italicStyle = css`
  font-style: italic;
`

export const Italic = styled.em`
  ${_italicStyle}
`

export const _underlineStyle = css`
  text-decoration: underline;
`

export const Underline = styled.span`
  ${_underlineStyle};
  font-weight: 300;
  overflow-wrap: break-word;
`

export const _hyperlinkStyle = css`
  color: ${colors.TEXT_LINK};
`

export const Hyperlink = styled.a`
  ${_hyperlinkStyle}
`

export const _listItemStyle = css`
  ${_paragraphStyle}
`

export const ListItem = styled(Paragraph).attrs((props) => ({
  ...props,
  as: 'li',
}))`
  ${_listItemStyle}

  p {
    display: inline;
  }
` as YakComponentOf<'li'>

export const _unorderedListStyle = css`
  color: inherit;
  list-style: none;
  margin: 1em 0;
  padding-left: 20px;

  & > li::before {
    content: '•';
    padding-right: 0.5em;
  }
`

export const UnorderedList = styled.ul`
  ${_unorderedListStyle}
`

export const _orderedListStyle = css`
  color: inherit;
  counter-reset: item;
  list-style: none;
  list-style: none;
  margin: 1em 0;
  padding-left: 20px;

  & > li {
    counter-increment: item;
    list-style-type: none;
    margin: 0;
    padding: 0 0 0 2em;
    text-indent: -2em;
  }

  & > li::before {
    content: counter(item) '.';
    display: inline-block;
    font-weight: 500;
    padding-right: 0.5em;
    text-align: right;
    width: 1em;
  }
`

export const OrderedList = styled.ol`
  ${_orderedListStyle}
`

export const _blockQuoteStyle = css`
  ${heading.styles.L}
  display: inline-flex;
  line-height: 38px;
  margin: 8px 0;

  &::before {
    border-left: 2px ${colors.PRIMARY_SAND_200} solid;
    content: '';
    padding-right: 26px;
  }
`

export const BlockQuote = styled(heading.L).attrs((props) => ({
  as: 'blockquote',
  ...props,
}))`
  p {
    ${_blockQuoteStyle}
  }
` as YakComponentOf<'blockquote'>
